module.exports = __webpack_public_path__ + "static/img/mpdpBottom1.98ed953.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpdpBottom1.png
// module id = 9v7z
// module chunks = 2